import { render, staticRenderFns } from "./headerBar.vue?vue&type=template&id=0a159d4c&"
import script from "./headerBar.vue?vue&type=script&lang=js&"
export * from "./headerBar.vue?vue&type=script&lang=js&"
import style0 from "./headerBar.vue?vue&type=style&index=0&id=0a159d4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports